import * as yup from 'yup';

export default yup.object().shape({
  disco_id: yup.string().required('Merchant is required!'),
  vendor_type: yup.string().required('Vendor type is required!'),
  meter_no: yup.string().required('Meter number is required!'),
  amount: yup.string().required('Amount is required!')
});
